import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { CountryListResponse } from 'src/models/country.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { selectUnauthedJsonAddressulatorRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_COUNTRYS_INIT = 'data/countries/GET_COUNTRYS_INIT'
export const GET_COUNTRYS_SUCCESS = 'data/countries/GET_COUNTRYS_SUCCESS'
export const GET_COUNTRYS_FAILURE = 'data/countries/GET_COUNTRYS_FAILURE'

export type GetCountrysSuccessPayload = CountryListResponse[]

export interface GetCountrysInitAction {
  type: typeof GET_COUNTRYS_INIT
}
export interface GetCountrysSuccessAction {
  type: typeof GET_COUNTRYS_SUCCESS
  payload: GetCountrysSuccessPayload
}
export interface GetCountrysFailureAction {
  type: typeof GET_COUNTRYS_FAILURE
  payload: unknown
}

export type GetCountrysActions =
  | GetCountrysInitAction
  | GetCountrysSuccessAction
  | GetCountrysFailureAction

export const createGetCountrysInitAction = (): GetCountrysInitAction => ({
  type: GET_COUNTRYS_INIT,
})
const createGetCountrysSuccessAction = (
  payload: GetCountrysSuccessPayload,
): GetCountrysSuccessAction => ({
  type: GET_COUNTRYS_SUCCESS,
  payload,
})
const createGetCountrysFailureAction = (
  err: unknown,
): GetCountrysFailureAction => ({
  type: GET_COUNTRYS_FAILURE,
  payload: err,
})

export const getCountrys = (): ThunkAction<
  Promise<void>,
  RootState,
  void,
  GetCountrysActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetCountrysActions>,
    getState: () => RootState,
  ): Promise<void> => {
    const locale = selectNullSafeLocaleFromState(getState())
    dispatch(createGetCountrysInitAction())
    return axios
      .get(
        `/?locale=${locale}`,
        selectUnauthedJsonAddressulatorRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(createGetCountrysSuccessAction(response.data))
        },
        (err) => {
          dispatch(createGetCountrysFailureAction(err.response.data))
        },
      )
  }
}
